import { render, staticRenderFns } from "./LatestPostStreamer.vue?vue&type=template&id=0a74074c&"
import script from "./LatestPostStreamer.vue?vue&type=script&lang=js&"
export * from "./LatestPostStreamer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports